import { render } from "./NotFound.vue?vue&type=template&id=e7aab31e"
const script = {}

import exportComponent from "/var/www/html/frezka-saas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__